import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import saveAs from 'file-saver';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { FarmersApplicationService } from 'src/app/services/farmers-application.service';

@Component({
  selector: 'app-ready-for-payment',
  templateUrl: './ready-for-payment.component.html',
  styleUrls: ['./ready-for-payment.component.scss']
})
export class ReadyForPaymentComponent implements OnInit {

  public appVerificationItems: MenuItem[];
  public userId: any;

  public loading: boolean = false;
  public readyForPaymentData: any = [];

  public subscriptions: any = []
  public subjectSub: any;

  public selectedContractor: any;
  public contractorList: any = [];
  public showDetailTable: boolean = false;

  public selectedAppStatus: any;
  public appStatusTypeList: any = [];

  public filteredDataForExport: any = [];
  public date: any;
  // public filteredData: any = [];
  public totalSelectedApp: any;

  uploadDetailsForm: FormGroup;
  public ipAddress: any = '000.000.000';
  public itRateList: any = [];
  public statusList: any = [];

  public responseDate: any = [];
  public loadingExportResponse: boolean = false;

  selectedOutlet: any = null;
  contractorOutletList: any = [];

  constructor(
    private loader: AppLoaderService,
    private activityRecordService: ActivityRecordService,
    private deptDashBoardService: DepartmentDashboardService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private cryptoJsService: CryptoJsService,
    private ipService: IpAddressService,
    public cd: ChangeDetectorRef,
    public router: Router,
    private service: BaseService,
    private vendorService: VendorDashboardService,
    private _fb: FormBuilder,
    private _personalDetalSer: FarmersDetailsService,
    private fApplicationService: FarmersApplicationService,
  ) { }

  ngOnInit(): void {
    this.getIP();
    this.date = new Date();
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));    
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;


    this.uploadDetailsForm = this._fb.group({
      mbPhotoPath: ['', Validators.required],
      taxPhotoPath: [''],
      status: ['', Validators.required],
      consentCheckboxValue1: [false, Validators.required],
      consentCheckboxValue2: [false, Validators.required],
      consentCheckboxValue3: [false, Validators.required],
      consentCheckboxValue4: [false, Validators.required],
      remarks: ['Recommended for payment and forward to DMICADA', Validators.required],
      // gstRate: [{ value: '2%', disabled: true }, Validators.required],
      // itRate: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
      // labourCessRate: [{ value: '1%', disabled: true }, Validators.required],
    });
    
    this.appVerificationItems = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.filteredDataForExport, `Filtered_Apps_Ready_for_Payment_(${this.date})`);
        },
      },
    ];

    // this.loadITRateList();
    this.loadStatusList();

    this.loadContractor(this.userId);
    this.getAppStatusTypeList();
  }

  loadITRateList(){
    setTimeout(() => {
      this.itRateList = [
      {
        label: '0%',
        value: 0,
      },
      {
        label: '1%',
        value: 1,
      },
      {
        label: '2%',
        value: 2,
      },
      {
        label: '3%',
        value: 3,
      },
      {
        label: '4%',
        value: 4,
      },
      {
        label: '5%',
        value: 5,
      },
    ]
    }, 100);
  }

  loadStatusList(){
    setTimeout(() => {
      this.statusList = [
      {
        label: 'Forward to DMICADA',
        value: 'S',
      }
    ]
    }, 100);
  }

  get uploadFormControls() {
    return this.uploadDetailsForm.controls;
  }

  getAppStatusTypeList() {
    setTimeout(() => {
      this.appStatusTypeList = [
        {
          status_Code: 1,
          status_Description: 'Pending'
        },
        // {
        //   status_Code: 2,
        //   status_Description: 'Current'
        // },
        {
          status_Code: 3,
          status_Description: 'Approved'
        }
      ]
    }, 200)
  }

  loadContractor(userId) { 
    this.loader.start();
    let sub = this.vendorService
    .getContractorMaster(userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();          
          if (data.length > 0) {
            this.contractorList = data;
          }
          else {
            this.contractorList = [];
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }
        },
        error: (err) => {
          this.loader.close(); 
          this.contractorList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'App Id': d?.APP_ID,
          'Farmer Name': d?.Name,
          'Farmer Type': d?.FarmerType,
          'Caste': d?.Caste_Description,
          'Programme Name': d?.ProposedSystem,
          'District': d?.District,  
          'Village': d?.Village,
          'Block': d?.Block,
          'Father Name': d?.Father_name,
          'Mobile No': d?.Mobile,
          'Contractor Name': d?.ContractorName,
          'Outlet': d?.Outlets,
          'Agreement No': d?.AgreementNo,
          'Total Area': d?.TotalArea,
          'XEN Re-verification Remarks': d?.ReVerRemarksXEN,
          'Total Rec Amount': d?.TotalRecommendedAmt,
          '85% of Cost': d?.totalCost85Per,
          'Lot Status': d?.LotStatus,
          // 'JE Remarks': d?.JE_Remarks,
          // 'JE Status': d?.JE_Status,
          // 'JE Id': d?.JEID,
          // 'XEN Remarks': d?.XEN_Remarks,
          // 'XEN Status': d?.XEN_Status,
          // 'Centre_share_amt': d?.LotCentre_share_amt,
          // 'State_share_amt': d?.LotLotState_share_amt,
          // 'TopUp': d?.TopUp,		
          // 'Status': '',		
          // 'Remarks': '',		
          // 'PFMSPaymentDate': d?.PFMSPaymentDate,		
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  refreshTable() {
    // this.loadData(this.userId)
    if(this.selectedContractor){
      this.loadData(this.selectedContractor?.ContractorCode, this.userId, this.selectedOutlet?.OutletId);
    }
    // if(this.selectedContractor && this.selectedAppStatus){
    //   this.loadData(this.selectedContractor?.ContractorCode, this.userId, this.selectedAppStatus?.status_Description);
    // }
  }

  onSelectContractor(){
    // if(this.selectedContractor && this.selectedAppStatus){
    //   this.showDetailTable = true;
    //   this.loadData(this.selectedContractor?.ContractorCode, this.userId, this.selectedAppStatus?.status_Description);
    // }
    this.selectedOutlet = null;
    this.contractorOutletList = [];
    
    if(this.selectedContractor){
      this.getContractorOutletList(this.selectedContractor?.ContractorCode, '', 'lotGeneratation');
    }
  }

  onSelectContractorOutlet(){
    if(this.selectedContractor && this.selectedOutlet){
      this.showDetailTable = true;
      this.filteredDataForExport = [];
      this.totalSelectedApp = 0;
      this.loadData(this.selectedContractor?.ContractorCode, this.userId, this.selectedOutlet?.OutletId);
    }
  }

  getContractorOutletList(contractorId, userId, status) {
    this.loader.start();
    this.fApplicationService
      .getOutletByContractor(contractorId, userId, status)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.contractorOutletList = res;
        },
        error: (err) => {
          this.loader.close();
          this.contractorOutletList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  loadData(contractorId, userId, outlet) { 
    // this.loader.start();
    this.loading = true;
    let sub = this.deptDashBoardService
      .getAppsForLotGenerationEPC(contractorId, userId, outlet)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;
          
          if (data.length > 0) {
            this.readyForPaymentData = data.map(val => ({
              ...val,
              totalCost85Per: (val?.TotalRecommendedAmt*0.85).toFixed(2)
            }));
          }
          else {
            this.readyForPaymentData = [];
          
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }

          this.activityRecordService.activityRecord( this.userId, 'Ready For Payment (grid load)', '', new Date(), 'Success' );
        },
        error: (err) => {
          this.loading = false;
          this.readyForPaymentData = [];
          this.activityRecordService.activityRecord( this.userId, 'Ready For Payment Error(grid load)', '', new Date(), `${err}` );

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  onRowSelect(event) {
    this.calculation();
    this.messageService.add({
      severity: 'info',
      summary: 'Product Selected',
      detail: event.data.name,
    });
  }

  onRowUnselect(event) {
    this.calculation();
    this.messageService.add({
      severity: 'info',
      summary: 'Product Unselected',
      detail: event.data.name,
    });
  }

  onHeaderCheckboxToggle(event){
    this.calculation();
    let length = this.filteredDataForExport.length;
    if(event.checked){
      this.messageService.add({
        severity: 'info',
        summary: 'Multiple Product Selected',
        detail: `Total ${length} Products Selected`,
      });
    }
    else{
      this.messageService.add({
        severity: 'info',
        summary: 'Multiple Product Unselected',
        detail: '',
      });
    }
  }

  calculation(){
    // this.filteredData = [];
    // this.filteredDataForExport = event.filteredValue;
    this.totalSelectedApp = 0;
    // this.totalSubToFarmer = 0;
    // this.totalSubToVendor = 0;
    // this.totalFarmerRefund = 0;
    
    this.totalSelectedApp = this.filteredDataForExport.length;
    // this.filteredDataForExport.forEach((val) => {
    //   this.totalSubToFarmer += val.SubsidyToFarmer_Amount;
    //   this.totalSubToVendor += val.SubsidyToVendor_Amount;
    //   this.totalFarmerRefund += val.FarmerRefund_Amount;
    // })
    // this.filteredDataForExport.forEach(val => {
    //   this.filteredData.push(
    //     {
    //       appID: val.Scheme_Specific_Id, 
    //       programID: val.ProgramID,
    //       subsidy_Amt: 0,  
    //       amt_Disbus_to_Vendor: 0, 
    //       amt_Refund_to_Farmer: 0, 
    //       farmerShareToVendor: val.Farmer_Share_To_Vendor, 
    //       state_share_amt: val.State_Share_Payment_Amount, 
    //       centre_share_amt: val.Center_Share_Payment_Amount, 
    //   }) 
    // })
  }

  onUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);
    // let phNo = this.farmerMobNo;
    let phNo = this.userId;
    this._personalDetalSer.uploadFile(data, phNo, formcontrol).subscribe((resp: any) => {
      if (resp.statusCode == 200) {
        this.uploadDetailsForm.patchValue({ [formcontrol]: resp.data });
      }
    })
    uploadElement.clear();
  }

  onSubmitDetails(){
    if(!this.uploadDetailsForm.value.consentCheckboxValue1 || !this.uploadDetailsForm.value.consentCheckboxValue2 || !this.uploadDetailsForm.value.consentCheckboxValue3 || !this.uploadDetailsForm.value.consentCheckboxValue4){
      this.messageService.add({ severity: 'warn', summary: 'Warn Message', detail: 'Please provide consent to proceed further.' });
      return;
    }
    if(this.uploadDetailsForm.valid){

      let reqBody = [
        {
          UserId: this.userId,
          MBDocPath: this.uploadDetailsForm.get('mbPhotoPath')?.value,
          TaxDocPath: this.uploadDetailsForm.get('taxPhotoPath')?.value,
          // GST: 2,
          // IncomeTax: this.uploadDetailsForm.get('itRate')?.value,
          // LabourCess: 1,
          Network_Id: this.ipAddress,
          Terminal_Id: this.ipAddress,
          Data: this.filteredDataForExport.map(val => ({
            AppId: val?.APP_ID,
            ProgId: val?.Program_Id,
            Status: this.uploadDetailsForm.value.status,
            Remarks: this.uploadDetailsForm.value.remarks,
            PFMSPaymentDate: new Date(val?.PFMSPaymentDate)
          }))
        }
      ]

      this.insertStatePhysicalFinData(reqBody);
      // this.uploadLotDetails(payload);
    }
  }

  insertStatePhysicalFinData(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.responseDate = [];
    this.loader.start();
    this.loadingExportResponse = true;
    this.deptDashBoardService
      .importLotsEPC(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();

          // if (res == "Success") {
          //   this.messageService.add({
          //     severity: 'success',
          //     summary: 'Success Message',
          //     detail: res,
          //   });
          //   this.clearPFMSpaymentStatusData();
          // } else {
          //   this.messageService.add({
          //     severity: 'info',
          //     summary: 'Info Message',
          //     detail: res,
          //   });
          // }
          this.loadingExportResponse = false;

          this.loader.close();
          this.responseDate = res;

          this.responseDate.forEach((val, i) => {
            if(val?.IsCorrect == 0){
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: this.responseDate[i].Message });
              return;
            }
            
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Submitted' });
          });
          this.activityRecordService.activityRecord(this.userId, 'PFMS Payment Status', ``, new Date(), `${res}`, reqBody);
        },
        error: (err) => {
          this.loadingExportResponse = false;
          this.loader.close();
          this.responseDate = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });

          this.activityRecordService.activityRecord(this.userId, 'PFMS Payment Status Error', ``, new Date(), `${err}`, reqBody);
        },
      });
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    }else{
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress',JSON.stringify(this.ipAddress));
      });
    }
  }

  responseGridBackgroundColor(product){
    if (product.IsCorrect == 0) {
      return '#ff8080';
    } else return '#ffffff';
  }

  closeResponseTable(){
    this.responseDate = [];
    this.uploadDetailsForm.reset();
    this.refreshTable();
    this.filteredDataForExport = [];
    this.calculation();
    this.uploadDetailsForm.controls.remarks.setValue('Recommended for payment and forward to DMICADA');
  }

  rowBackgroundColor(product){
    if(product.OfflinePaymentStatus == 'Offline Payment'){
      // return 'rgba(191, 246, 231, 1)';
      return '#ffc966';
    }else {
      if(product.LotStatus == 'Success'){
        return '#99e699';
      }else{
        return '#ffb3b3';
      }
    }
  }
}